import { EyeInvisibleOutlined, EyeOutlined, HolderOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Typography } from 'antd';

import { IconButton } from '@/shared/ui/IconButton';

import styles from './ColumnVisibilityButton.module.css';
import type { ColumnConfig } from './types';

type ColumnVisibilityItemProps<T extends string = string> = {
  id: string;
  columnConfig: ColumnConfig<T>;
  onToggleVisibility: (key: T) => void;
};

export const ColumnVisibilityItem = <T extends string = string>({
  id,
  columnConfig,
  onToggleVisibility,
}: ColumnVisibilityItemProps<T>) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className={styles.columnItem}>
      <div className={styles.columnItemLeft} {...attributes} {...listeners}>
        <HolderOutlined className={styles.dragHandle} />
        <Typography.Text ellipsis={{ tooltip: columnConfig.title }} className={styles.columnTitle}>
          {columnConfig.title}
        </Typography.Text>
      </div>
      <IconButton
        size="small"
        onClick={() => onToggleVisibility(columnConfig.key)}
        className={styles.visibilityButton}
        tooltip={columnConfig.visible ? '컬럼 숨기기' : '컬럼 표시'}>
        {columnConfig.visible ? <EyeOutlined size={16} /> : <EyeInvisibleOutlined size={16} />}
      </IconButton>
    </div>
  );
};
